import Vue from 'vue';
import App from './App.vue';

import selectHeating from './components/select-heating.vue';
import radioGroup from './components/radio-group.vue';
import formOil from './components/form-oil.vue';
import formElectric from './components/form-electric.vue';
import formWood from './components/form-wood.vue';
import formGeothermal from './components/form-geothermal.vue';
import formDistrict from './components/form-district.vue';


Vue.component('select-heating', selectHeating);
Vue.component('radio-group', radioGroup);
Vue.component('form-oil', formOil);
Vue.component('form-electric', formElectric);
Vue.component('form-wood', formWood);
Vue.component('form-geothermal', formGeothermal);
Vue.component('form-district', formDistrict);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#jaspi-selector-tool');
